var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobArdinPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bcbcbc;}.cls-2{fill:#e8e8e8;}.cls-3{fill:#777;}.cls-4{fill:#301d29;}.cls-5{fill:#5b4956;}.cls-6{fill:#d61846;}.cls-7{fill:#cecece;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "251.79 241.51 28.21 241.51 31.09 198.91 23.19 177.47 72.44 161.73 207.56 161.73 256.81 177.47 248.91 198.91 251.79 241.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "279.5 279.5 0.5 279.5 1.5 260.5 6.49 239.65 140 190.5 273.51 239.65 278.5 260.5 279.5 279.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "257.64 313.36 22.36 313.36 4.68 233.76 140 184.28 275.32 233.76 257.64 313.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "221 77.38 170.47 26.27 110.28 26.27 59.75 77.38 56.86 139.28 69.95 207.45 106.69 207.45 174.06 207.45 210.8 207.45 223.9 139.28 221 77.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "154.42 50.75 125.58 50.75 74.75 82.17 72.42 142.19 87.03 188.38 117.78 212.26 162.22 212.26 192.82 188.38 207.59 142.19 205.25 82.17 154.42 50.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "78.7 163.31 101.23 166.96 119.67 185.82 133.66 209.08 100.36 206.43 86.6 188.56 78.7 163.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "208.04 141.78 140 151.85 71.96 141.78 67.51 113.59 140 103.52 212.49 113.59 208.04 141.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "150.83 104.69 140 166.48 129.17 104.69 87.89 72.74 140 68.55 192.11 72.74 150.83 104.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "200.92 163.31 178.39 166.96 159.95 185.82 145.96 209.08 179.26 206.43 193.05 188.56 200.92 163.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "223.52 72.43 171.18 19.49 108.82 19.49 56.48 72.43 53.48 136.55 67.05 207.17 79.67 207.17 65.43 150.34 80.28 101.76 114.08 73 165.92 73 199.72 101.76 214.57 150.34 200.33 207.17 212.95 207.17 226.52 136.55 223.52 72.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "236.82 254.86 139.7 274.86 43.18 254.86 37.01 212.26 47.49 186.19 63.8 183.92 98.96 202.02 140 209.38 181.04 202.02 216.2 183.92 232.51 186.19 242.99 212.26 236.82 254.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "163.54 73 115.86 73 109.5 18.32 169.9 18.32 163.54 73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobArdinPilot);
export default __webpack_public_path__ + "static/media/mob-ardin-pilot.8f10295a469f2ee3853f77a19ce0bd53.svg";
export { ForwardRef as ReactComponent };